import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EmailRequest } from '../models/emailrequest.model';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class EmailrequestService {

	private svcUrl = '/EmailRequests';

	constructor(private http: HttpClient, private url: UrlService) { }

	getEmailRequest(id: number): Observable<EmailRequest> {
		return this.http.get<EmailRequest>(this.url.getBaseURL() + this.svcUrl + '/' + id);
	}

	getEmailRequestsForBrokerId(id: number, isDismissed?: boolean | null, itemStart?: number | null, itemCount?: number | null) {
		let params = new HttpParams()
			.set('IsDismissed', (isDismissed == null ? false : isDismissed))
			.set('ItemStart', (itemStart == null ? 0  : itemStart))
			.set('ItemCount', (itemCount == null ? 100 : itemCount));
		return this.http.get<EmailRequest[]>(this.url.getBaseURL() + this.svcUrl + '/Broker/' + id, { params });
	}

	getEmailRequestsForUserId(id: string, isDismissed?: boolean | null, itemStart?: number | null, itemCount?: number | null) {
		let params = new HttpParams()
			.set('IsDismissed', (isDismissed == null ? false : isDismissed))
			.set('ItemStart', (itemStart == null ? 0 : itemStart))
			.set('ItemCount', (itemCount == null ? 100 : itemCount));
		return this.http.get<EmailRequest[]>(this.url.getBaseURL() + this.svcUrl + '/User/' + id, { params });
	}

	dismissBatchEmailRequests(ids: number[]): Observable<EmailRequest[]> {
		return this.http.post<EmailRequest[]>(this.url.getBaseURL() + this.svcUrl + '/DismissBatch', ids);
	}

	dismissEmailRequest(id: number): Observable<EmailRequest> {
		return this.http.post<EmailRequest>(this.url.getBaseURL() + this.svcUrl + '/Dismiss/' + id, {});
	}

	createEmailRequest(item: EmailRequest): Observable<EmailRequest> {
		return this.http.post<EmailRequest>(this.url.getBaseURL() + this.svcUrl, item);
	}

	createEmailRequestWithAttachment(file: FormData): Observable<EmailRequest> {
		return this.http.post<EmailRequest>(this.url.getBaseURL() + this.svcUrl + '/WithAttachment', file);
	}

	createEmailRequestWithExternalEmailAttachment(item: EmailRequest): Observable<EmailRequest[]> {
		return this.http.post<EmailRequest[]>(this.url.getBaseURL() + this.svcUrl + '/WithExternalEmailAttachment', item);
	}


}
